var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-7",
  "use": "meta-7-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-7\"><path d=\"M24.125 6H7.875A1.874 1.874 0 0 0 6 7.875v16.25C6 25.161 6.839 26 7.875 26h16.25A1.874 1.874 0 0 0 26 24.125V7.875A1.874 1.874 0 0 0 24.125 6zm.625 17.5c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25v-15c0-.69.56-1.25 1.25-1.25h15c.69 0 1.25.56 1.25 1.25v15zm-7.5-13.073v-.052h-4.375v11.25h1.25v-3.75h3.125v-.052a3.75 3.75 0 0 0 0-7.396zm-.625 6.198h-2.5v-5h2.5a2.5 2.5 0 1 1 0 5z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol